import { useQuery } from "@apollo/client";
import { LinearProgress } from "@material-ui/core";
import ConfigForm, { ConfigInput } from "components/Layout/ConfigForm";
import {
  GetShiftsAfterDateQuery,
  GetShiftsAfterDateQueryResult,
} from "generated/graphql";
import { GET_SHIFTS_AFTER_DATE } from "lib/shifts";
import React, { Fragment } from "react";
import PlaybackLocationsLoader from "./PlaybackLocationsLoader";
import PlaybackMap from "./PlaybackMap";
import ShiftPlaybackSlider from "./ShiftPlaybackSlider";

interface PlaybackLoaderProps {
  shiftNumber: number;
  shiftDate: string;
  buildingId: string;
}

export default function PlaybackLoader({
  shiftNumber,
  shiftDate,
  buildingId,
}: PlaybackLoaderProps) {
  const { loading, error, data }: GetShiftsAfterDateQueryResult = useQuery(
    GET_SHIFTS_AFTER_DATE,
    {
      variables: {
        buildingId: buildingId,
        _gte: shiftDate,
      },
    }
  );

  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else {
    return <PlaybackLocationsLoader shiftId={data?.Shift[shiftNumber].Id} />;
  }
}
